import initialState from '../../reducers/initialState';
import * as types from 'actions/actionTypes';

export default function (state = initialState.reducerAlters, action) {
    switch (action.type) {
        case types.ALTERNATIVE_CAT_LIST_UPDATE:
            return {
                alterList: action.payload ? action.payload : [{}],
            }
        default:
            return state;
    }
}
